// removed by extract-text-webpack-plugin
module.exports = {"verticalInfoGrid":"verticalInfoGrid","locale-CN":"locale-CN"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/VerticalInfoGrid/VerticalInfoGrid.scss
// module id = ab8Z
// module chunks = 0